import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';

import portfolio1 from '../assets/images/portfolio1.jpg';
import portfolio2 from '../assets/images/portfolio2.jpg';
import portfolio3 from '../assets/images/portfolio3.jpg';
import portfolio4 from '../assets/images/portfolio4.jpeg';
import portfolio5 from '../assets/images/portfolio5.jpg';
import portfolio6 from '../assets/images/portfolio6.jpg';

const portfolioImages = [
  portfolio4,
  portfolio5,
  portfolio6,
  portfolio1,
  portfolio2,
  portfolio3
];

// Helper to chunk array into groups of size n
function chunkArray(arr, chunkSize) {
  const chunks = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize));
  }
  return chunks;
}

const Portfolio = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });

    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // On desktop, chunk by 3 images per slide; on mobile no chunking (one image per slide)
  const slides = isMobile ? portfolioImages.map(img => [img]) : chunkArray(portfolioImages, 3);

  return (
    <section id="portfolio" className="py-5 bg-light">
      <div className="container">
        <h2 className="text-center mb-4">Our Portfolio</h2>

        <Carousel indicators interval={4000} pause="hover">
          {slides.map((group, idx) => (
            <Carousel.Item key={idx}>
              <div className="row">
                {group.map((imgSrc, i) => (
                  <div
                    key={i}
                    className={isMobile ? "col-12" : "col-md-4"}
                    data-aos="zoom-in"
                    data-aos-delay={i * 150}
                  >
                    <img
                      src={imgSrc}
                      alt={`Portfolio ${idx * 3 + i + 1}`}
                      className="img-fluid rounded shadow"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default Portfolio;
